import { Button, Card, Form, Input, Modal, Select, Popconfirm, Row, Col, Checkbox, Table } from "antd";
import React, { useEffect, useState } from "react";

import { recordError } from "../../../utils/logService";
import util from "../../../utils/functions/custom";
import commonApi from "../../../services/commonLookupService";
import lookupApi from "../../../services/citizenScienceLookupService";
import TextArea from "antd/lib/input/TextArea";
import { ContactField } from "../../custom/ContactField";

const EditParticipant = ({
  data,
  roles = [],
  visible,
  onCancel,
  onModalSubmit,
  formType,
  loading
}) => {
  const [disabled, setDisabled] = useState(true);
  const [titles, setTitles] = useState([]);
  // const [roles, setRoles] = useState([]);
  const [participantStatuses, setParticipantStatuses] = useState([]);
  const [formTitle, setFormTitle] = useState("Scientist");
  const [formEdit, setFormEdit] = useState(false);
  const [gender, setGender] = useState([]);
  const [race, setRace] = useState([]);
  const [ageGroup, setAgeGroup] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [province, setProvince] = useState();
  const [district, setDistrict] = useState();
  const [town, setTown] = useState();
  const [districts, setDistricts] = useState([]);
  const [towns, setTowns] = useState([]);
  const [participantType, setParticipantType] = useState([]);
  const [disabilities, setDisabilities] = useState([]);
  const [motivations, setMotivations] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [selectedMotivations, setSelectedMotivations] = useState([]);

  useEffect(() => {
    // getParticipantRoles();
    getTitles();
    getParticipantStatuses();
    getGenders();
    getRaces();
    getAgeGroups();
    getprovinceData();
    getParticipantTypes();
    getParticipantStatuses();
    getDisabilities();
    getParticipantsMotivations();
    onFormLoad();
  }, [data, formType]);

  const [form] = Form.useForm();
  const { Option } = Select;
  const formName = "EditParticipantInfo";
  
  const getTitles = async () => {
    try {
      const response = await commonApi.getTitles();
      if (response) {
        const { data } = response;
        setTitles(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getGenders = async () => {
    try {
      const response = await commonApi.getGenders();
      if (response) {
        const { data } = response;
        setGender(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getRaces = async () => {
    try {
      const response = await commonApi.getRaces();
      if (response) {
        const { data } = response;
        setRace(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getprovinceData = async () => {
    try {
      const response = await commonApi.getProvincesDistrictTowns();
      if (response && response.status === 200) {
        const { data } = response;
        setProvinces(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getAgeGroups = async () => {
    try {
      const response = await commonApi.getAgeGroup();
      if (response) {
        const { data } = response;
        setAgeGroup(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getDisabilities = async () => {
    try {
      const response = await commonApi.getDisability();
      if (response) {
        const { data } = response;
        setDisabilities(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
  };

  //   const getParticipantRoles = async () => {
  //     try {
  //       const response = await lookupApi.getParticipantRoles(false);
  //       if (response) {
  //         const { data } = response;
  //         const transformData = data.map((c) => ({
  //           label: c.value,
  //           value: c.key,
  //           key: c.key,
  //         }));
  //         setRoles(transformData);
  //       }
  //     } catch (error) {
  //       recordError(error);
  //     }
  //   };

  const getParticipantStatuses = async () => {
    try {
      const response = await lookupApi.getParticipantStatuses();
      if (response) {
        const { data } = response;
        setParticipantStatuses(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getParticipantTypes = async () => {
    try {
      const response = await commonApi.getParticipantTypes();
      if (response) {
        const { data } = response;
        setParticipantType(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getParticipantsMotivations = async () => {
    try {
      const response = await commonApi.getParticipantsMotivations();
      if (response && response.status === 200) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));
        setMotivations(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onFormLoad = () => {
    if (!util.isEmpty(data)) {
      const selectedTitle = titles.find(
        (record) => record.key === data.title.key
      );
      const selectedStatus = participantStatuses.find(
        (record) => record.key === data.status.key
      );

      const selectedRole = data?.roles?.map(x =>x.key);

      const _motivations = data.motivations?.map((d) => d.key);

      form.setFieldsValue({
        id: data.id,
        firstname: data.firstname,
        lastname: data.lastname,
        uuid: data.uuid,
        contactNumber: data.contactNumber,
        email: data.email,
        title: selectedTitle,
        gender: data.gender.value,
        disability: data.disability.value,
        ageGroup: data.ageGroup.value,
        motivations: _motivations,
        status: data.status,
        race: data.race,
        roles: selectedRole,
        participantType: data.type.value,
        province: data.location.province?.value,
        district: data.location.district?.value,
        town: data.location.town?.value,
      });

      setSelectedRole(selectedRole);
    }
    if (formType === "Add") {
      setFormTitle("Add Scientist");
      setFormEdit(false);
      form.resetFields();
      setSelectedRole([])
    } else {
      setFormTitle("Edit/Approve Scientist");
      setFormEdit(true);
    }
  };

  const handleContactChange = (value) => {
    if (value === 0 || value.length < 10) {
      form.setFieldsValue({ contactNumber: undefined });
      return;
    }
    form.setFieldsValue({ contactNumber: value });
  };

  const handleProvinceChange = (value) => {
    setProvince(value);
    setDistricts(provinces.find((prov) => prov.key == value).districts);
  };

  const handleDistrictChange = (value) => {
    setDistrict(value);
    setTowns(districts.find((district) => district.key == value).towns);
  };

  const handleCityChange = (value) => {
    setTown(value);
  };

  const onTitleChange = (selected) => {
    const selectedTitle = titles.find((record) => record.key == selected);
    form.setFieldsValue({ title: selectedTitle });
  };

  const onStatusChange = (selected) => {
    const selectedStatus = participantStatuses.find(
      (record) => record.key == selected
    );
    form.setFieldsValue({ status: selectedStatus });
  };

  const onRoleChange = (selectedValue) => {
    form.setFieldsValue({ roles: selectedValue });
    setSelectedRole(selectedValue);
  };

  const onPopCancel = () => {
    onCancel();
    setDisabled(true);
    setFormEdit(false);
    form.resetFields();
  };

  const Confirm = () => {
    onCancel();
    form.resetFields();
    setFormEdit(false);
  };

  const onSubmit = (values) => {
    if (values?.roles?.hasOwnProperty('key')) {
      const roles = values?.roles.map(c=>c.key) 
      values.roles = roles;
    }
    
    if (formType === "Add") {

      let statusId = participantStatuses.find((record) => record.value === "Approved");
      if (statusId !== undefined) {
        values.status = statusId.key;
      }

    }

    onModalSubmit(values);
    selectedMotivations([]);
    setSelectedRole([]);
    form.resetFields();
    setFormEdit(false);
  };

  return (
    <Modal
      title={formTitle}
      open={visible}
      closable={false}
      keyboard={false}
      maskClosable={false}
      onCancel={onCancel}
      width={1200}
      footer={[
        <div className="modal-footer-buttons">
          <Popconfirm
            key="2"
            title="Are you sure you want to cancel...you will lose all info entered?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => Confirm()}
            onCancel={onPopCancel}
            disabled={disabled}
          >
            <Button onMouseUp={() => onPopCancel()} style={{ marginLeft: 10 }}>
              Cancel
            </Button>
          </Popconfirm>
          <Button
            type="primary"
            htmlType="submit"
            onSubmit={onSubmit}
            form={formName}
            loading={loading}
          >
            Save
          </Button>
        </div>,
      ]}
    >
      <Form name={formName} form={form} layout="vertical" onFinish={onSubmit}>
        <Row>
          <Col xs={24} md={6}>
            <Form.Item
              label="Title"
              name="title"
              rules={[
                {
                  required: true,
                  message: "Title is required",
                },
              ]}
            >
              <Select onChange={onTitleChange}>
                {titles.map((title) => (
                  <Option key={title.key}> {title.value}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={6} style={{ marginLeft: 20 }}>
            <Form.Item
              label="Name"
              name={"firstname"}
              rules={[
                {
                  required: true,
                  message: "Name is required",
                },
              ]}
            >
              <Input name="firstname" onBlur={onNameBlur} />
            </Form.Item>
          </Col>
          <Col xs={24} md={6} style={{ marginLeft: 20 }}>
            <Form.Item
              label="Surname"
              name={"lastname"}
              rules={[
                {
                  required: true,
                  message: "Surname is required",
                },
              ]}
            >
              <Input name="lastname" onBlur={onNameBlur} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={6}>
            <Form.Item
              label="Cellphone Number"
              name="contactNumber"
              rules={[
                { required: true, message: "Please enter your contact number" },
                {
                  min: 10,
                  message: "Contact length expects 10 numeric values",
                },
              ]}
            >
              {formEdit === true ? (
                <Input disabled={false} />
              ) : (
                <ContactField onContactChange={handleContactChange} />
              )}
            </Form.Item>
          </Col>
          <Col xs={24} md={6} style={{ marginLeft: 20 }}>
            <Form.Item
              label="Email Address"
              name={"email"}
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail",
                },
                {
                  required: true,
                  message: "Please enter your E-mail",
                },
              ]}
            >
              <Input name="email" disabled={formEdit} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={6}>
            <Form.Item
              label="Disability"
              name={"disability"}
              rules={[
                {
                  required: true,
                  message: "Disability is required",
                },
              ]}
            >
              <Select disabled={formEdit}>
                {disabilities.map((disable) => (
                  <Option key={disable.key}> {disable.value}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={6} style={{ marginLeft: 20 }}>
            <Form.Item
              label="Gender"
              name={"gender"}
              rules={[
                {
                  required: true,
                  message: "Gender is required",
                },
              ]}
            >
              <Select disabled={formEdit}>
                {gender.map((gen) => (
                  <Option key={gen.key}> {gen.value}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={6} style={{ marginLeft: 20 }}>
            <Form.Item
              label="Race"
              name={"race"}
              rules={[
                {
                  required: true,
                  message: "Race is required",
                },
              ]}
            >
              <Select disabled={formEdit}>
                {race.map((rac) => (
                  <Option key={rac.key}> {rac.value}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={6}>
            <Form.Item
              label="Age Group"
              name={"ageGroup"}
              rules={[
                {
                  required: true,
                  message: "Age range is required",
                },
              ]}
            >
              <Select disabled={formEdit}>
                {ageGroup.map((age) => (
                  <Option key={age.key}> {age.value}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {/* {!formEdit && ( */}
            <Col xs={24} md={6} style={{ marginLeft: 20 }}>
              <Form.Item
                label="Participants Type"
                name={"participantType"}
                rules={[
                  {
                    required: true,
                    message: "Public type is required",
                  },
                ]}
              >
                <Select disabled={formEdit}>
                  {participantType.map((part) => (
                    <Option key={part.key}> {part.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          {/* )} */}
        </Row>
      
        {formEdit && <Row>
            <Col xs={24} md={12}>
              <Form.Item
                label="Reason for joining the project "
                name="motivations"
                rules={[
                  {
                    required: false,
                    message:
                      "Please select at least one reason for joining the project",
                  },
                ]}
              >
                <Checkbox.Group
                  disabled={!!formEdit}
                  options={motivations}
                  style={{ display: "flex", flexDirection: "column" }}
                />
              </Form.Item>
            </Col>
        </Row>}
          <Row>
            <Col xs={24} md={6}>
              <Form.Item
                name={"province"}
                label="Province"
                rules={[
                  {
                    required: true,
                    message: "Please select Province",
                  },
                ]}
              >
                <Select value={province} onChange={handleProvinceChange} disabled={!!formEdit}>
                  {provinces?.map((option) => (
                    <Option key={option.key}>{option.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={6} style={{ marginLeft: 20 }}>
              <Form.Item
                name={"district"}
                label="District"
                rules={[
                  {
                    required: true,
                    message: "Please select District",
                  },
                ]}
              >
                <Select value={district} onChange={handleDistrictChange} disabled={!!formEdit}>
                  {districts?.map((dist) => (
                    <Option key={dist.key}>{dist.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={6} style={{ marginLeft: 20 }}>
              <Form.Item
                name={"town"}
                label="Nearest Town"
                rules={[
                  {
                    required: false,
                    message: "Please select nearest City/Town",
                  },
                ]}
              >
                <Select value={town} onChange={handleCityChange} disabled={!!formEdit}>
                  {towns?.map((town) => (
                    <Option key={town.key}>{town.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        <Row>
          <Col xs={12} md={12}>
            <Form.Item
              name="roles"
              label="Scientist roles"
              rules={[{ required: true, message: "Please select a role" }]}
            >
              <Select
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                placeholder="Please select"
                onSelect={onRoleChange}
                onChange={onRoleChange}
                value={selectedRole}
                defaultValue={selectedRole}
                labelInValue
              >
                {roles.map((role) => (
                  <Option key={role.key} value={role.key}>
                    {role.value}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
            <Col xs={6} md={6} style={{ marginLeft: 40 }}>
              <Form.Item
                name="status"
                label="Scientist Status"
                rules={[{ required: true, message: "Please select a status" }]}
              >
                <Select onChange={onStatusChange} allowClear disabled={!!formEdit}>
                  {participantStatuses?.map((status) => (
                    <Option
                      key={status.key}
                      disabled={status.value === "Submitted"}
                    >
                      {status.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditParticipant;